/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrderFilterRequestDto { 
    statuses?: Array<OrderFilterRequestDto.StatusesEnum>;
    salesEmails?: Array<string>;
    customerEmails?: Array<string>;
    fakturaIds?: Array<string>;
    keywords?: Array<string>;
    deviceIds?: Array<number>;
    hasDeviceAllocations?: boolean;
}
export namespace OrderFilterRequestDto {
    export const StatusesEnum = {
        Created: 'CREATED',
        AssignedToCustomer: 'ASSIGNED_TO_CUSTOMER',
        Submitted: 'SUBMITTED',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED',
        All: 'ALL',
        AllUnresolved: 'ALL_UNRESOLVED'
    } as const;
    export type StatusesEnum = typeof StatusesEnum[keyof typeof StatusesEnum];
}


export type StatusesEnum = typeof OrderFilterRequestDto.StatusesEnum[keyof typeof OrderFilterRequestDto.StatusesEnum];
